import gql from 'graphql-tag';

import byDokkioLabelIDCountFragment from './byDokkioLabelIDCountFragment';
import byDokkioLabelNameCountFragment from './byDokkioLabelNameCountFragment';
import byIntegrationCountFragment from './byIntegrationCountFragment';
import byIntegrationItemKindCountFragment from './byIntegrationItemKindCountFragment';

export const countsFragment = gql`
  fragment countsFragment on Counts {
    dokkioClass
    conversationCount
    dokkioUsersCount
    dokkioTagByDokkioLabel {
      ...byDokkioLabelIDCountFragment
    }
    integrationItemByIntegration {
      ...byIntegrationCountFragment
    }
    integrationItemByIntegrationItemKind {
      ...byIntegrationItemKindCountFragment
    }
    integrationEmailByIntegration {
      ...byIntegrationCountFragment
    }
    integrationThreadByIntegration {
      ...byIntegrationCountFragment
    }
    webpageCount
    logosCount
    pendingDokkioUsersCount
    suggestedSyncFolderRemoteItemsCount
    suggestedDokkioTagByDokkioLabel {
      ...byDokkioLabelNameCountFragment
    }
    unlabeledDokkioTagCount
    suggestedUnlabeledDokkioTagCount
    suggestedDokkioLabelCount
  }
  ${byDokkioLabelIDCountFragment}
  ${byDokkioLabelNameCountFragment}
  ${byIntegrationCountFragment}
  ${byIntegrationItemKindCountFragment}
`;
export default countsFragment;
